import * as routes from '../../routes/route'

export const logOut = () => {
    localStorage.clear();
    window.location.href = routes.LOGIN_WITH_EMAIL_ENDPOINT
}
